import { useEffect } from 'react';

declare global {
  interface Window {
    lenis?: {
      destroy: () => void;
      start: () => void;
    };
  }
}

export const useLenisScroll = () => {
  useEffect(() => {
    // Store the original Lenis instance
    const originalLenis = window.lenis;

    // Disable Lenis when the widget loads
    if (originalLenis) {
      originalLenis.destroy();
    }

    // Re-enable Lenis when the widget unmounts
    return () => {
      if (originalLenis) {
        originalLenis.start();
      }
    };
  }, []);
}; 